import medullaLogo from '../assets/medulla-logo.png';
import medullaMark from '../assets/medulla-mark.png';

/**
 * Full lockup (mark + wordmark). Used where nothing else on screen says who this is — the sign-in
 * screen, before the hub shell (and its own sense of "you're inside something") exists at all.
 */
export function MedullaLogo() {
  return <img src={medullaLogo} alt="Medulla" className="topbar__logo topbar__logo--full" />;
}

/**
 * The mark alone. Used inside the hub shell: the sidebar is already open and doing the identifying
 * work, so the topbar only needs a compact brand anchor next to the section name, not the full
 * wordmark again.
 */
export function MedullaMark() {
  return <img src={medullaMark} alt="Medulla" className="topbar__logo topbar__logo--mark" />;
}
